import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  drawer: {
    background: theme.palette.common.white,
    zIndex: 2000
  },
  menuItem: {
    height: theme.spacing(6)
  },
  activeItem: {
    backgroundColor: '#e0dddd'
  },
  menuIcon: {
    justifyContent: 'center',
    marginLeft: -8
  },
  primaryText: {
    maxWidth: 160,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: 'dimgray'
  },
  roles: {
    display: 'grid'
  },
  subItems: (props) => ({
    marginTop: 20,
    marginLeft: props.isExpanded ? 170 : 56,
    transition: 'margin-left 0.3s ease'
  }),
  profile: {
    color: theme.palette.primary.dark
  },
  button: {
    display: 'flex'
  },
  textButton: {
    textTransform: 'none',
    marginLeft: 15
  },
  labelWrapper: (props) => ({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: props.isExpanded ? 200 : 0,
    opacity: props.isExpanded ? 1 : 0,
    transition: 'max-width 0.3s ease, opacity 0.3s ease'
  })
}))

export default useStyles
